import type { Paint, Swatch } from '@proofroom/schema';

/** The pink used for template image placeholders. */
export const PLACEHOLDER_FILL = '#f6cfdc';
export const PLACEHOLDER_STROKE = '#d98aa6';

export function isNone(p?: Paint): boolean {
  return !p || p.swatch === 'None' || (!p.hex && !p.swatch);
}

/**
 * CSS colour for a Paint.
 *
 * The exporter resolves `hex` through InDesign's own `app.colorTransform`, after scaling the ink
 * values for the tint, which is how InDesign tints. A tint cannot be reproduced by blending the
 * solid towards white in sRGB, so an unresolved paint falls back to the solid swatch rather than
 * inventing a lighter colour that InDesign never renders.
 */
export function paintCss(p: Paint | undefined, swatches: Swatch[] = []): string {
  if (isNone(p)) return 'none';
  if (p!.hex) return p!.hex;
  const sw = swatches.find((s) => s.name === p!.swatch);
  return sw?.hex || 'none';
}

export function opacityCss(opacity: number | undefined): number {
  if (opacity === undefined || Number.isNaN(opacity)) return 1;
  return Math.max(0, Math.min(1, opacity / 100));
}
